<template>
	<div class="JsonTableField" :class="{ error }">
		<div v-if="!disabled">
			<span v-if="!control.settings?.additional?.columnsMin || columnMisfit || control.settings?.additional?.columnsMin != control.settings?.additional?.columnsMax">
				Columns <input type="number" v-model="columns" class="input dim" :disabled="disabled" :min="control.settings?.additional?.columnsMin ?? 1" :max="control.settings?.additional?.columnsMax ?? 100" />
			</span>
			<span v-if="!control.settings?.additional?.rowsMin || rowsMisfit || control.settings?.additional?.rowsMin != control.settings?.additional?.rowsMax">
				Rows <input type="number" v-model="rows" class="input dim" :disabled="disabled" :min="control.settings?.additional?.rowsMin ?? 1" :max="control.settings?.additional?.rowsMax ?? 100" />
			</span>
		</div>
		<table v-if="value" style="width: 100%;">
			<tr v-for="row, r of value?.tableData ?? []" :key="r" class="row">
				<td v-for="val, c of row" :key="r + '_' + c" :class="{ header: r == 0 }" class="col">
					<input type="text" v-model="row[c]" class="input cell" @blur="$emit('change', value)" :disabled="disabled" />
				</td>
				<th style="vertical-align: middle;">
					<mdi v-if="!disabled && r >= 1" minus-circle @click="removeRow(r)" style="font-size: larger; color: var(--color-text-lightest);" />
				</th>
			</tr>
		</table>
		<mdi v-if="!disabled" plus-circle @click="rows++" style="font-size: larger; color: var(--color-text-lightest);" />
	</div>
</template>

<script>
import { field } from './FieldMixin.js'

// TODO: when i enter "10" in rows, i first type [1], then [0] this may remove existing data in the table
//       we need to handle this more gracefully somehow. maybe have a shadow model?

export default {
	name: 'JsonTableField',
	mixins: [ field ],
	props: {
		value: [ Object, Array ],
	},
	data: () => ({
		autoModel: false,
		rows: 0,
		columns: 0,
	}),
	computed: {
		// if the current data does not fit the min/max column settings, we need to show the columns input so the user can fix it
		columnMisfit() {
			return this.value?.tableData?.[0]?.length < this.control.settings.additional?.columnsMin || this.value?.tableData?.[0]?.length > this.control.settings.additional?.columnsMax
		},
		rowsMisfit() {
			return this.value?.tableData?.length < this.control.settings.additional?.rowsMin || this.value?.tableData?.length > this.control.settings.additional?.rowsMax
		},
	},
	watch: {
		value(n) {
			this.inferDims()
			this.onErrors([
				this.validateRequired(),
				this.validateTableSize(),
			])
		},
		rows(n, o) {
			if (n == o) return
			this.$emit('input', this.newModel())
		},
		columns(n, o) {
			if (n == o) return
			this.$emit('input', this.newModel())
		},
	},
	methods: {
		validateTableSize() {
			if (this.control.settings?.additional?.columnsMin && this.columns < this.control.settings.additional.columnsMin)
				return `Table must have at least ${ this.control.settings.additional.columnsMin } columns`
			if (this.control.settings?.additional?.columnsMax && this.columns > this.control.settings.additional.columnsMax)
				return `Table must have at most ${ this.control.settings.additional.columnsMax } columns`
			if (this.control.settings?.additional?.rowsMin && this.rows < this.control.settings.additional.rowsMin)
				return `Table must have at least ${ this.control.settings.additional.rowsMin } rows`
			if (this.control.settings?.additional?.rowsMax && this.rows > this.control.settings.additional.rowsMax)
				return `Table must have at most ${ this.control.settings.additional.rowsMax } rows`
		},
		newModel() {
			const a = []
			for (let r = 0; r < this.rows; r++) {
				const row = []
				for (let c = 0; c < this.columns; c++) {
					const defaultValue = r == 0 ? `Column ${ c + 1 }` : ''
					row.push(this.value?.tableData?.[r]?.[c] ?? defaultValue)
				}
				a.push(row)
			}
			return { tableData: a }
		},
		validate() {
			this.onErrors([
				this.validateRequired(),
			])
		},
		removeRow(r) {
			if (this.rows <= 1) return
			const a = this.value?.tableData ?? []
			a.splice(r, 1)
			this.rows--
		},
		inferDims() {
			this.rows = this.value?.tableData?.length ?? this.control?.settings?.additional?.rowsMin ?? 4
			this.columns = this.value?.tableData?.[0]?.length ?? this.control?.settings?.additional?.columnsMin ?? 2
		},
	},
	mounted() {
		this.inferDims()
		if (!this.value) {
			this.$emit('input', this.newModel())
		}
	},
}
</script>

<style scoped>
.dim { width: 60px; margin-right: 10px; text-align: center; }
.cell { text-align: center; border-radius: 0; }
.header .cell { font-weight: bold; }
td { padding: 0; }
.row:first-child .col:first-child .cell { border-top-left-radius: 10px; }
.row:first-child .col:last-of-type .cell { border-top-right-radius: 10px; }
.row:last-child .col:first-child .cell { border-bottom-left-radius: 10px; }
.row:last-child .col:last-of-type .cell { border-bottom-right-radius: 10px; }
</style>
